<div class="sidebar">
  <div class="sidebar-toggle">
    <div class="sidebar-toggle-item" routerLinkActive="active" [routerLink]="['/home']" #rlaHome="routerLinkActive">
      <img [src]="'../../../assets/icons/sidebar/home'+(rlaHome.isActive?'-active':'')+'.svg'">
    </div>

    <div class="sidebar-toggle-item" routerLinkActive="active" [routerLink]="['/camera']"
         #rlaCamera="routerLinkActive">
      <img [src]="'../../../assets/icons/sidebar/camera'+(rlaCamera.isActive?'-active':'')+'.svg'">
    </div>

    <div class="sidebar-toggle-item" routerLinkActive="active" [routerLink]="['/users']"
         #rlaUsers="routerLinkActive">
      <img [src]="'../../../assets/icons/sidebar/users'+(rlaUsers.isActive?'-active':'')+'.svg'">
    </div>

    <div class="sidebar-toggle-item">
      <img src="../../../assets/icons/sidebar/community.svg">
    </div>
  </div>

  <div class="sidebar-menu-wrapper">
    <ul class="sidebar-menu" *ngIf="rlaHome.isActive">
      <li class="sidebar-menu-item" routerLinkActive="active"
          [routerLink]="['/home/jobs']">
        Jobs
      </li>
      <!--<li class="sidebar-menu-item">-->
        <!--Uploader-->
      <!--</li>-->
      <!--<li class="sidebar-menu-item"-->
          <!--routerLinkActive="active"-->
          <!--[routerLink]="['/home/transactions']"-->
          <!--[routerLinkActiveOptions]="{exact: true}">-->
        <!--Transactions-->
      <!--</li>-->
      <!--<li class="sidebar-menu-item"-->
          <!--routerLinkActive="active"-->
          <!--[routerLink]="['/home/products']"-->
          <!--[routerLinkActiveOptions]="{exact: true}">-->
        <!--Products-->
      <!--</li>-->
    <!--</ul>-->
    <!--<ul class="sidebar-menu" *ngIf="rlaUsers.isActive">-->
      <!--<li class="sidebar-menu-item"-->
          <!--routerLinkActive="active"-->
          <!--[routerLink]="['/users/agencies']"-->
          <!--[routerLinkActiveOptions]="{exact: true}">-->
        <!--Agencies-->
      <!--</li>-->
      <!--<li class="sidebar-menu-item"-->
          <!--routerLinkActive="active"-->
          <!--[routerLink]="['/users/agents']"-->
          <!--[routerLinkActiveOptions]="{exact: true}">-->
        <!--Agents-->
      <!--</li>-->
      <!--<li class="sidebar-menu-item"-->
          <!--routerLinkActive="active"-->
          <!--[routerLink]="['/users/contractors']"-->
          <!--[routerLinkActiveOptions]="{exact: true}">-->
        <!--Contractors-->
      <!--</li>-->
    </ul>
  </div>

  <div class="sidebar-support">
    <img src="../../../assets/icons/sidebar/support.svg">
    <span>Support</span>
  </div>
</div>